import FreeWeight1 from '../assets/images/free-weight-room1-800w.avif'
import FreeWeight2 from '../assets/images/free-weight-room2-800w.avif'
import FreeWeight3 from '../assets/images/free-weight-room3-800w.avif'
import FreeWeight4 from '../assets/images/free-weight-room16-800w.avif'

import Machine1 from '../assets/images/machine-room1-800w.avif'
import Machine2 from '../assets/images/machine-room4-800w.avif'
import Machine3 from '../assets/images/machine-room3-800w.avif'
import Machine4 from '../assets/images/machine-room22-800w.avif'
import Machine5 from '../assets/images/machine-room24.jpeg'

import Cardio1 from '../assets/images/cardio-room1-800w.avif'
import Cardio2 from '../assets/images/cardio-room2-800w.avif'
import Cardio3 from '../assets/images/cardio-room3-800w.avif'

import Gym5837 from '../assets/images/gym-5837-1200w.avif'
import Gym5596 from '../assets/images/gym-5596-1200w.avif'
import Gym5449 from '../assets/images/gym-5449-1200w.avif'
import Gym5508 from '../assets/images/gym-5508-1200w.avif'

import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import HeadingOne from '../components/HeadingOne';
import { Link } from 'react-router-dom';

const allImages = [
    FreeWeight1, Machine1, Gym5837,
    Cardio1, Gym5508, FreeWeight2,
    Machine2, Cardio2, Gym5449,
    FreeWeight3, Machine3, Gym5596,
    Cardio3, FreeWeight4, Machine4,
    Machine5,
];

const PicturesPage = () => {
    useEffect(() => {
        document.title = `Impressies - Private Gym Schijndel`;
    }, []);

    const [activeImageUrl, setActiveImageUrl] = useState('');

    return (
        <>
            <section className="pictures-hero">
                <div className="default-container flex justify-center items-center h-full w-full">
                    <div className="text-center">
                        <HeadingOne>Impressies.</HeadingOne>
                        <h3 className="text-primary-500 pt-2 pb-16">Neem een kijkje naar de sportschool.</h3>
                    </div>
                </div>
            </section>

            <section className="bg-gray-100">
                <div className="default-container">
                    <div className="columns-2 md:columns-3 gap-4 md:gap-5">
                        {allImages.map((image, i) => (
                            <div
                                key={i}
                                onClick={() => setActiveImageUrl(image)}
                                className="break-inside-avoid mb-4 md:mb-5 cursor-pointer rounded overflow-hidden shadow-lg zoom"
                            >
                                <img
                                    src={image}
                                    alt="Private Gym Schijndel"
                                    className="w-full h-auto block"
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section>
                <div className="small-container">
                    <h2 className="text-center">Bekijk ook onze socials.</h2>
                    <div className="bg-white shadow-2xl rounded flex flex-col mt-12">
                        <div className="sub-menu grid md:grid-cols-5 grid-cols-3 justify-between text-primary-500 text-2xl">
                            <Link target="_blank" to="https://www.instagram.com/privategym.schijndel/">
                                <div className="text-4xl"><FontAwesomeIcon icon={faInstagram}/></div>
                                <div className="text-sm pt-2 text-gray-400">Instagram</div>
                            </Link>
                            <Link target="_blank" to="https://www.facebook.com/privategymschijndel">
                                <div className="text-4xl"><FontAwesomeIcon icon={faFacebook}/></div>
                                <div className="text-sm pt-2 text-gray-400">Facebook</div>
                            </Link>
                            <Link target="_blank" to="https://www.linkedin.com/in/nick-van-schijndel-0528a0139/?originalSubdomain=nl">
                                <div className="text-4xl"><FontAwesomeIcon icon={faLinkedin}/></div>
                                <div className="text-sm pt-2 text-gray-400">LinkedIn</div>
                            </Link>
                            <Link target="_blank" to="https://www.researchgate.net/profile/Nick-Van-Schijndel">
                                <div className="text-4xl font-bold leading-none">RG</div>
                                <div className="text-sm pt-2 text-gray-400">ResearchGate</div>
                            </Link>
                            <Link to="https://wa.me/+31683371313">
                                <div className="text-3xl"><FontAwesomeIcon icon={faWhatsapp}/></div>
                                <div className="text-sm pt-2 text-gray-400">WhatsApp</div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {activeImageUrl && (
                <div onClick={() => setActiveImageUrl('')} className="highlight-picture-overlay">
                    <div className="overlay-cross">
                        <FontAwesomeIcon icon={faX}/>
                    </div>
                    <div className="flex items-center justify-center h-screen">
                        <img
                            src={activeImageUrl}
                            alt="Private Gym Schijndel"
                            className="max-h-[85vh] max-w-[90vw] w-auto rounded shadow-2xl"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default PicturesPage;
